import { CanActivate, Router } from "@angular/router";
import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { isPlatformServer } from "@angular/common";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Injectable()
export class PrescriptionGuard implements CanActivate {
    environmentVariables: any;
    constructor(
        private router: Router,
        private pagesService: StaticPagesService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.pagesService.getenvConfig().subscribe((res) => {
            if (res) {
                this.environmentVariables = res;
            }
        });
    }

    canActivate() {
        if (isPlatformServer(this.platformId)) {
            return true;
        }

        if (this.environmentVariables) {
            if (this.environmentVariables?.enable_prescription) {
                return true;
            } else {
                this.router.navigate(["/"]); //back to home page
                return false;
            }
        } else {
            return this.pagesService.getConfigrationVariables().map((res) => {
                if (res.code === 200) {
                    this.environmentVariables = res?.data;
                    if (
                        this.environmentVariables &&
                        this.environmentVariables?.enable_prescription
                    ) {
                        return true;
                    }
                    this.router.navigate(["/"]); //back to home page
                    return false;
                }
                return false;
            });
        }
    }
}
